module.exports = __webpack_public_path__ + "static/media/IconoReferenciasBibliograficas.97118c10.svg";